import { useEffect } from "react";

export const useDragAndDropTable = ({
  formData,
  onUpdateOrder,
  containerRef,
   dragReady = true,
}) => {
  useEffect(() => {
    if (
      !dragReady ||
      !containerRef?.current ||
      !Array.isArray(formData) ||
      formData.length === 0
    )
      return;

    const tableBody = containerRef.current.querySelector("tbody");
    if (!tableBody) return;

    const rows = tableBody.querySelectorAll("tr");

    let draggedId = null;

    // Clean up previous listeners
    rows.forEach((row) => {
      const oldHandle = row.querySelector(".drag-handle");
      if (oldHandle) {
        oldHandle.removeAttribute("draggable");
        oldHandle.onmousedown = null;
        oldHandle.ondragstart = null;
        oldHandle.ondragend = null;
      }
      row.ondragover = null;
      row.ondrop = null;
    });

    rows.forEach((row, index) => {
      const rowId = formData[index]?.id;
      if (!rowId) return;

      row.setAttribute("data-id", rowId.toString());

      const handle = row.querySelector(".drag-handle");
      if (!handle) return;

      handle.setAttribute("draggable", "true");

      handle.ondragstart = (e) => {
        draggedId = rowId.toString();
        e.dataTransfer.setData("text/plain", draggedId);
        row.style.opacity = "0.5";
        tableBody.setAttribute("data-dragging", "true");
      };

      handle.ondragend = () => {
        row.style.opacity = "1";
        tableBody.removeAttribute("data-dragging");
      };

      row.ondragover = (e) => {
        e.preventDefault();
        if (!tableBody.hasAttribute("data-dragging")) {
          e.dataTransfer.dropEffect = "none";
          return;
        }
      };

      row.ondrop = (e) => {
        e.preventDefault();
        if (!tableBody.hasAttribute("data-dragging")) return;

        const targetId = row.getAttribute("data-id");
        if (!draggedId || draggedId === targetId) return;

        const draggedIndex = formData.findIndex(
          (item) => item.id.toString() === draggedId
        );
        const targetIndex = formData.findIndex(
          (item) => item.id.toString() === targetId
        );

        if (draggedIndex === -1 || targetIndex === -1) return;

        const newData = [...formData];
        const [movedItem] = newData.splice(draggedIndex, 1);
        newData.splice(targetIndex, 0, movedItem);

        onUpdateOrder(
          newData.map((item, index) => ({
            ...item,
            position: index + 1,
          }))
        );
      };
    });

    // Cleanup on unmount or dependencies change
    return () => {
      rows.forEach((row) => {
        const handle = row.querySelector(".drag-handle");
        if (handle) {
          handle.removeAttribute("draggable");
          handle.onmousedown = null;
          handle.ondragstart = null;
          handle.ondragend = null;
        }
        row.ondragover = null;
        row.ondrop = null;
      });
      tableBody.removeAttribute("data-dragging");
    };
  }, [formData, onUpdateOrder, containerRef]);
};
